import { Dot, LoaderPill } from './LoadingPill.styles';

export const LoadingPill = () => {
  return (
    <LoaderPill>
      <Dot />
      <Dot />
      <Dot />
    </LoaderPill>
  );
};
